export namespace PowerLines {
  export const sockets = {
    type: 'sockets',
    icon: 'sockets',
    name: 'legrand-app.__SOCKETS',
  };
  export const lights = {
    type: 'lights',
    icon: 'light',
    name: 'legrand-app.__LEG_COM_LIGHTS',
  };
  export const heaters = {
    type: 'heaters',
    icon: 'heater',
    name: 'legrand-app.__LEG_RADIATORS',
  };
  export const cooktop = {
    type: 'cooktop',
    icon: 'oven',
    name: 'legrand-app.__LEG_COM_COOKING_APPLIANCES',
  };
  export const sanitary_hot_water = {
    type: 'sanitary_hot_water',
    icon: 'domestic-hot-water',
    name: 'legrand-app.__LEG_COM_WATER_HEATERS',
  };
  export const air_conditioner = {
    type: 'air_conditioner',
    icon: 'air-conditioner',
    name: 'legrand-app.__AIR_CONDITIONERS',
  };
  export const other = {
    type: 'other',
    icon: 'flash',
    name: 'legrand-app.__OTHER',
  };
  export const electric_charger = {
    type: 'electric_charger',
    icon: 'electric-car',
    name: 'legrand-app.__LEG_COM_EV_CHARGER'
  };
  export const fridge = {
    type: 'fridge',
    icon: 'fridge',
    name: 'legrand-app.__LEG_COM_FRIDGES',
  };
  export const oven = {
    type: 'oven',
    icon: 'oven',
    name: 'legrand-app.__LEG_COM_OVEN'
  };
  export const dishwasher = {
    type: 'dishwasher',
    icon: 'dishwasher',
    name: 'legrand-app.__LEG_COM_DISHWASHERS',
  };
  export const washing_machine = {
    type: 'washing_machine',
    icon: 'washing',
    name: 'legrand-app.__LEG_COM_WASHING_MACHINES',
  };
  export const tumble_dryer = {
    type: 'tumble_dryer',
    icon: 'dryer',
    name: 'legrand-app.__LEG_COM_DRYERS',
  };
  export const multimedia = {
    type: 'multimedia',
    icon: 'multimedia',
    name: 'legrand-app.__LEG_COM_MULTIMEDIA',
  };
  export const machine = {
    type: 'machine',
    icon: 'machine',
    name: 'legrand-app.__MACHINE',
  };
  export const swimming_pool = {
    type: 'swimming_pool',
    icon: 'pool',
    name: 'legrand-app.__SWIMMING_POOL',
  };
  export const solar_panel = {
    type: 'solar_panel',
    icon: 'solar-panel',
    name: '',
  };
  export const rest_of_home = {
    type: 'rest_of_home',
    icon: 'elsewhere',
    name: 'legrand-app.__LEG_REST_OF_THE_HOME',
  };
}
